import httpClient from '@/api/http-client'

const urlPrefix = '/bpm/v1'

/**
 * API для управляения процессами.
 *
 */
export default {

  /**
   * Получение списка портов.
   *
   * @param {String} processId
   * @returns {*}
   */
  ports( processId ) {

    return httpClient.http
      .get( `${urlPrefix}/executor/processes/${processId}/ports` )
      .then( response => {
        return response.data
      })
  },

  /**
   * Получение формы данных для запуска процесса.
   *
   * @param {String} publicationId
   * @returns {*}
   */
  startForm( publicationId ) {

    return httpClient.http
      .get( `${urlPrefix}/catalog/publications/${publicationId}/form` )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Получение формы данных для завершения процесса.
   *
   * @param {String} processId
   * @param {String} portId
   * @returns {*}
   */
  finishForm( processId, portId ) {

    return httpClient.http
      .get( `${urlPrefix}/executor/processes/${processId}/ports/${portId}` )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Получение входящих и исходящих данных процесса.
   *
   * @param {String} processId
   * @returns {*}
   */
  data( processId ) {

    return httpClient.http
      .get( `${urlPrefix}/executor/processes/${processId}/extra_data` )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Запуск процесса.
   *
   * @param {String} publicationId
   * @param {Object} data
   * @param {Object} options
   * @returns {*}
   */
  start( publicationId, data, options = {} ) {

    const _data = { data }

    if ( typeof options.contractorId === 'string' ) {
      _data.contractor_id = options.contractorId
    }

    if ( typeof options.startDate === 'string' ) {
      _data.start_date = options.startDate
    }

    if ( typeof options.finishDate === 'string' ) {
      _data.finish_date = options.finishDate
    }

    if ( typeof options.name === 'string' ) {
      _data.name = options.name
    }

    if ( typeof options.description === 'string' ) {
      _data.description = options.description
    }

    if ( typeof options.system === 'object' ) {
      _data.system = options.system
    }

    if ( Array.isArray( options.contractors ) ) {
      _data.contractors = options.contractors
    }

    return httpClient.http
      .put( `${urlPrefix}/catalog/publications/${publicationId}`, _data )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Завершение процесса.
   *
   * @param {String} processId
   * @param {String} portId
   * @param {Object} data
   * @returns {Promise<T>}
   */
  finish( processId, portId, data ) {

    const _data = {
      data: data,
      port_id: portId
    }

    return httpClient.http
      .patch( `${urlPrefix}/executor/processes/${processId}/finish`, _data )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Редактирование процесса.
   *
   * @param processId
   * @param data
   * @param options
   * @returns {Promise<T>}
   */
  edit( processId, data, options = {} ) {

    const _data = { data }

    if ( typeof options.startDate === 'string' ) {
      _data.start_date = options.startDate
    }

    if ( typeof options.finishDate === 'string' ) {
      _data.finish_date = options.finishDate
    }

    if ( typeof options.name === 'string' ) {
      _data.name = options.name
    }

    if ( typeof options.description === 'string' ) {
      _data.description = options.description
    }

    if ( Array.isArray( options.contractors ) ) {
      _data.contractors = options.contractors
    }

    return httpClient.http
      .patch( `${urlPrefix}/processes/${processId}/edit`, _data )
      .then( response => {
        return response.data
      } )
  }
}



// WEBPACK FOOTER //
// ./src/apps/bpm/api/run/api.js